import { createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { id: "manual-payment" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", null, [
  /*#__PURE__*/_createVNode("h6", { class: "font-normal" }, " Pembayaran Komisi Kurir ")
], -1)
const _hoisted_4 = { class: "flex gap-2" }
const _hoisted_5 = { class: "text-sm" }
const _hoisted_6 = /*#__PURE__*/_createVNode("i", { class: "pi pi-sort-down text-sm" }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("p", { class: "text-sm" }, "Filter Tanggal", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("i", { class: "pi pi-sort-down text-sm" }, null, -1)
const _hoisted_9 = { style: {"min-height":"70vh !important"} }
const _hoisted_10 = { key: 0 }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "mt-3" }, [
  /*#__PURE__*/_createVNode("div", { class: "m-auto" }, [
    /*#__PURE__*/_createVNode("p", { class: "color-blue-grey text-center font-bold" }, [
      /*#__PURE__*/_createTextVNode("Gunakan filter tanggal untuk "),
      /*#__PURE__*/_createVNode("br"),
      /*#__PURE__*/_createTextVNode("Mengeluarkan data")
    ])
  ])
], -1)
const _hoisted_12 = { key: 1 }
const _hoisted_13 = {
  class: "overflow-y-auto small-scroll-y px-2",
  style: {"max-height":"8rem"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ListBlankCourier = _resolveComponent("ListBlankCourier")
  const _component_TableComissionPayment = _resolveComponent("TableComissionPayment")
  const _component_Card = _resolveComponent("Card")
  const _component_FilterDatePayout = _resolveComponent("FilterDatePayout")
  const _component_OverlayPanel = _resolveComponent("OverlayPanel")
  const _component_FormManualComission = _resolveComponent("FormManualComission")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    _createVNode(_component_Card, { class: "" }, {
      title: _withCtx(() => [
        _createVNode("div", _hoisted_2, [
          _hoisted_3,
          _createVNode("div", _hoisted_4, [
            (_ctx.filterDate)
              ? (_openBlock(), _createBlock("div", {
                  key: 0,
                  class: ["btn-custom-outline flex cursor-pointer gap-2 px-2 py-1 items-center", _ctx.filtersAgent.value ? 'primary-color' : 'grey-color'],
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showDropdownFromAgent($event)))
                }, [
                  _createVNode("p", _hoisted_5, _toDisplayString(_ctx.filtersAgent.label), 1),
                  _hoisted_6
                ], 2))
              : _createCommentVNode("", true),
            _createVNode("div", {
              class: ["btn-custom-outline flex cursor-pointer gap-2 px-2 py-1 items-center", _ctx.filterDate ? 'primary-color' : 'grey-color'],
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showDropDown($event)))
            }, [
              _hoisted_7,
              _hoisted_8
            ], 2)
          ])
        ])
      ]),
      content: _withCtx(() => [
        _createVNode("div", _hoisted_9, [
          (!_ctx.filterDate)
            ? (_openBlock(), _createBlock("div", _hoisted_10, [
                _createVNode(_component_ListBlankCourier),
                _hoisted_11
              ]))
            : (_openBlock(), _createBlock("div", _hoisted_12, [
                _createVNode(_component_TableComissionPayment, {
                  data: _ctx.dataTable,
                  onPayComission: _ctx.openModalManualComission
                }, null, 8, ["data", "onPayComission"])
              ]))
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_OverlayPanel, {
      ref: "dateOp",
      id: "filter_overlay_panel",
      class: "p-5"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_FilterDatePayout, {
          data: _ctx.dataSourceFilter,
          onSubmitDate: _ctx.submitDateFilter
        }, null, 8, ["data", "onSubmitDate"])
      ]),
      _: 1
    }, 512),
    _createVNode(_component_OverlayPanel, {
      ref: "agentOp",
      class: "p-4"
    }, {
      default: _withCtx(() => [
        _createVNode("div", _hoisted_13, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.listAgent, (data, index) => {
            return (_openBlock(), _createBlock("ul", {
              class: ["mb-2 listFilter cursor-pointer", data.value === _ctx.filtersAgent.value ? 'color-primary' : ''],
              onClick: ($event: any) => (_ctx.selectedAgent($event, data)),
              key: 'agent-' + index
            }, [
              _createVNode("li", null, _toDisplayString(data.label), 1)
            ], 10, ["onClick"]))
          }), 128))
        ])
      ]),
      _: 1
    }, 512),
    (_ctx.isShowDialog === true)
      ? (_openBlock(), _createBlock(_component_FormManualComission, {
          key: 0,
          dataForm: _ctx.dataPaymentById,
          isShowDialog: _ctx.isShowDialog,
          onHideDialog: _ctx.hideDialog,
          onReloadData: _ctx.reloadData
        }, null, 8, ["dataForm", "isShowDialog", "onHideDialog", "onReloadData"]))
      : _createCommentVNode("", true)
  ]))
}